import type { MarketTrade } from '../api/useMarketTrades';

/**
 * Merge several trade lists into one, deduped by trade id and sorted newest-first.
 *
 * Sources are scanned in order, so when the same trade id appears in more than one
 * source the first one wins — pass higher-priority sources (e.g. live) first.
 */
export function mergeTradeSources(sources: MarketTrade[][]): MarketTrade[] {
    const seen = new Set<string>();
    const all: MarketTrade[] = [];

    for (const source of sources) {
        for (const t of source) {
            if (seen.has(t.id)) continue;
            seen.add(t.id);
            all.push(t);
        }
    }

    all.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
    return all;
}
